/** Fine-grained capabilities checked against `Profile.user_access` from `/me`. */
export enum Permission {
  /** `/_app/_admin/*` routes (DISTRI, INDUSTRIAL, ADMIN). */
  AccessAdminRoutes = 'access:admin-routes',
  Import = 'import',
  Pratiques = 'pratiques',
  Contracts = 'contracts',
  SamplingPlans = 'sampling-plans',
  Organisations = 'organisations',
  Users = 'users',
  Accounts = 'accounts',
  Orders = 'orders',
  SamplingPlansMap = 'sampling-plans-map',
  GpSamplingAssignment = 'gp-sampling-assignment',
  NgpSamplingAssignment = 'ngp-sampling-assignment',
  /** WIP navbar + routes (`/sampling-plans-map`, `/orders`, assignment recap, GP assignment). ADMIN only. */
  WipPages = 'wip-pages',
  /** NGP team assignment map for samplers (`/os/ngp-sampling-assignment`). */
  NgpSamplerAssignment = 'ngp-sampler-assignment',
  /** Edit contracts, batches, validation-form admin links, field insurance, etc. */
  ManageContracts = 'manage:contracts',
  /** Lot validation page (`/os/lots`). ADMIN only. */
  LotsValidation = 'lots-validation',
  /** OS lot review / shadow corrections (`/os/lot-reviews`). */
  OsLotReviews = 'os-lot-reviews',
  /** Header organisation filter (hidden for DISTRI). */
  OrganisationSelector = 'organisation-selector',
  /** Header accounts multi-select (hidden for INDUSTRIAL). */
  AccountsSelector = 'accounts-selector',
  /** Dashboard volume owner filter (OS / DISTRI only; hidden for INDUSTRIAL). */
  DashboardOwnerFilter = 'dashboard:owner-filter',
  /** GP surfaces choropleth map (`/os/surfaces-map`). */
  SurfacesMap = 'surfaces-map',
  /** OS allocation simulation page (`/os/surfaces-allocation`). */
  SurfacesAllocation = 'surfaces-allocation',
  /** Farmer follow-up validation forms (`/os/validation-forms`). */
  ValidationForms = 'validation-forms',
  /** Analysis results (`/results`). */
  Results = 'results',
}
